export const accountTypes: Dictionary<string> = {
  INDIVIDUAL: '1',
  CORPORATE: '2'
}
